import { useEffect, useState } from "react";
import { groupApi } from "../api/group.service";
import { DetailGroupType } from "../types";

export const useGetDetail = (id: string) => {
  const [data, setData] = useState<DetailGroupType | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const fetchData = async (id: string) => {
    try {
      setLoading(true);

      const response: any = await groupApi.detail(id);

      setData({
        ...(response?.data?.data?.detail_group[0] ?? null),
        vat: response?.data?.data?.vat ?? null,
      });

      return true;
    } catch (err: any) {
      console.log("Get detail group failed:", err);

      setError(err.message || "Something wrong");

      return false;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(id);
  }, []);

  return {
    data,
    fetchData,
    loading,
    error,
  };
};
